import { render, staticRenderFns } from "./ead-meus-cursos.vue?vue&type=template&id=12cc94cb&scoped=true&"
import script from "./ead-meus-cursos.vue?vue&type=script&lang=js&"
export * from "./ead-meus-cursos.vue?vue&type=script&lang=js&"
import style0 from "./ead-meus-cursos.vue?vue&type=style&index=0&id=12cc94cb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12cc94cb",
  null
  
)

export default component.exports